import { toQueryString } from "./helpers/toQueryString";
import type { RouteDefinition } from "./types";

const routesMap = {
  home: {
    path: "/",
    url: () => "/",
  },
  product: {
    path: "/",
    url: () => "/",
  },
  pricing: {
    path: "/pricing",
    url: () => "/pricing",
  },
  changelog: {
    path: "/changelog",
    url: () => "/changelog",
  },
  changelogPost: {
    path: "/changelog/:postId",
    url: ({ id }: { id: string }) => `/changelog/${id}`,
  },
  models: {
    path: "/models",
    url: () => "/models",
  },
  modelPost: {
    path: "/models/:modelId",
    url: ({ id }: { id: string }) => `/models/${id}`,
  },
  privacy: {
    path: "/privacy",
    url: () => "/privacy",
  },
  terms: {
    path: "/terms",
    url: () => "/terms",
  },
  login: {
    path: "/login",
    url: (params = {}) => `/login${toQueryString(params)}`,
  },
  signup: {
    path: "/signup",
    url: (params = {}) => `/signup${toQueryString(params)}`,
  },
  loginWithEmail: {
    path: "/login/email",
    url: (params = {}) => `/login/email${toQueryString(params)}`,
  },
  signupWithEmail: {
    path: "/signup/email",
    url: (params = {}) => `/signup/email${toQueryString(params)}`,
  },
  logout: {
    path: "/logout",
    url: () => "/logout",
  },
  onboarding: {
    path: "/onboarding",
    url: () => "/onboarding",
  },
  editor: {
    path: "/",
    url: () => `/`,
  },
  newFile: {
    path: "/new",
    url: () => "/new",
  },
  upgrade: {
    path: "/upgrade",
    url: () => "/upgrade",
  },
  settings: {
    path: "/settings/:category/",
    url: ({ category }: { category: string }) => `/settings/${category}/`,
  },
  chats: {
    path: "/chats/:chatId",
    url: ({ chatId }: { chatId: string }) => `/chats/${chatId}`,
    meta: {
      entityType: "chat",
      paramName: "chatId",
    },
  },
  prompts: {
    path: "/prompts/:promptId/",
    url: ({ promptId }: { promptId: string }) => `/prompts/${promptId}/`,
    meta: {
      entityType: "prompt",
      paramName: "promptId",
    },
  },
  evals: {
    path: "/evals/:evalId/",
    url: ({ evalId }: { evalId: string }) => `/evals/${evalId}/`,
    meta: {
      entityType: "eval",
      paramName: "evalId",
    },
  },
  embedPlayground: {
    path: "/embed/playground",
    url: () => "/embed/playground",
    meta: {
      entityType: "prompt",
      paramName: "promptId",
    },
  },
} as const satisfies Record<string, RouteDefinition>;

export { routesMap };
